var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 52,
    viewBox: "0 0 60 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.275711 51.8564L30.0674 0.398113L59.859 51.8564H0.275711ZM7.31738 47.7939H52.8174L30.0674 8.52311L7.31738 47.7939ZM30.3382 43.9346C30.925 43.9346 31.4103 43.7427 31.7939 43.359C32.1776 42.9754 32.3695 42.4901 32.3695 41.9033C32.3695 41.3165 32.1776 40.8313 31.7939 40.4476C31.4103 40.0639 30.925 39.8721 30.3382 39.8721C29.7514 39.8721 29.2662 40.0639 28.8825 40.4476C28.4988 40.8313 28.307 41.3165 28.307 41.9033C28.307 42.4901 28.4988 42.9754 28.8825 43.359C29.2662 43.7427 29.7514 43.9346 30.3382 43.9346ZM28.307 36.4189H32.3695V21.2523H28.307V36.4189Z",
    fill: "#645ADF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a4a4f6f7129ea4ddd6b642c5ca82e897.svg";
export { ForwardRef as ReactComponent };